<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-16 18:27:10
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-20 09:30:06
-->
<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    :colon="true"
    width="540px"
    label-width="85px"
    data-automation="addFlow"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.addFlow.name')" prop="name">
      <ux-input
        v-model="formData.name"
        :maxlength="50"
        :placeholder="$t('HT.upgrade.appType.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addFlow.rate')" prop="rate">
      <ux-input
        class="x-flew-one"
        v-model="formData.rate"
        :maxlength="9"
        :placeholder="$t('HT.addFlow.rate.placeholder', { min: this.maxRate })"
      ></ux-input>
      <ux-form-item class="unit-form" bottom="0" prop="unit" label-width="0px">
        <ux-select v-model="formData.unit" :options="$opt.unit"></ux-select>
      </ux-form-item>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        :maxlength="180"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '', // 名称
          rate: '', // 流量限制
          unit: '' // 时间单位
        };
      }
    },
    tableData: {
      type: Object,
      default: () => {
        return {
          list: [],
          totalSize: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      tabData: JSON.parse(JSON.stringify(this.tableData.list)),
      maxRate: 0,
      rules: this.$rul.addFlow(0)
    };
  },

  created() {
    this.getMaxRate();
  },

  methods: {
    getMaxRate() {
      for (let i = 0; i < this.tabData.length; i++) {
        if (this.maxRate < this.tabData[i].rate) {
          this.maxRate = this.tabData[i].rate;
        }
      }
      this.rules = this.$rul.addFlow(this.maxRate);
    },

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.unit-form {
  width: 120px;
  margin-left: 20px;
}
</style>
